import React, { useState, useEffect, useCallback } from 'react';
import { Button } from "@mui/material";
import Grid from '@mui/material/Grid2';
import { 
  ModelBase, 
} from "@models";
import { DataType } from '@dndModels/Types';

import DandDAPI from '@dndUtilities/system_api';

import StringBox from "@components/input/strings/StringBox";
import SelectObjectBox from "@components/input/selects/SelectObjectBox";
import LoadingBox from "@components/input/LoadingBox";

const api = DandDAPI.getInstance();

interface Props {
  name: string;
  data_type: DataType;
  type_name?: string;
  value?: string;
  values?: string[];
  filter?: any;
  multiple?: boolean;
  onChange: Function; 
  color?: string;
  disabled?: boolean;
  display_format?: string;
  display_format_backup?: string;
  log_it?: boolean;
  onCreating: (name: string, onComplete: (created: ModelBase) => void, onError: (error: any) => void) => void;
}

export default function SelectAddableObjectBox({ 
  name,
  data_type,
  type_name,
  multiple=false,
  value="",
  values=[],
  color="",
  disabled=false,
  filter={},
  display_format="{obj.true_name}",
  display_format_backup="{obj.name}",
  onChange,
  log_it=false,
  onCreating
}: Props) {
  const [fetched, setFetched] = useState(false);
  const [loading, setLoading] = useState(false);
  const [objects, setObjects] = useState<ModelBase[]>([]); 
  const [processing, setProcessing] = useState(false);
  const [my_value, setValue] = useState("");
  const [my_values, setValues] = useState<string[]>([]);
  const [newObjectMode, setNewObjectMode] = useState(false);
  const [newObjectStr, setNewObjectStr] = useState("");
  
  const load = useCallback( async () => {
    if (log_it) {
      debugger;
    }
    if (log_it) {
      console.log(data_type);
      console.log(filter);
    }
    const res = await api.getObjects<ModelBase>({ data_type, filter });
    if (log_it) {
      debugger;
      console.log(res);
    }
    setObjects(res);
    if (multiple) {
      const new_values = values.filter(o => res.some(o2 => o2._id === o));
      setValues(new_values);
    } if (res.some(o => o._id === value)) {
      setValue("");
    }
    setLoading(false);
  }, [data_type, filter, log_it]);

  useEffect(() => {
    if(!fetched) {
      setFetched(true);
      setLoading(true);
      setTimeout(() => {
        load();
      }, 100);
    }
  }, [fetched, load]);

  const addNewObject = () => {
    const obj = objects.find(o => o.name.toLowerCase() === newObjectStr.toLowerCase());
    if (obj) {
      if (multiple) {
        const new_values = [...my_values, obj._id];
        setValues(new_values);
        onChange(new_values);
      } else {
        const id = obj._id;
        setValue(id);
        onChange(id);
      }
      setNewObjectMode(false);
      setNewObjectStr("");
    } else {
      // debugger;
      setProcessing(true);
      onCreating(newObjectStr, (created) => {
        console.log(created);
        const new_values = [...my_values, created._id];
        setObjects([...objects, created]);
        if (multiple) {
          setValues(new_values);
          onChange(new_values);
        } else {
          const id = created._id;
          setValue(id);
          onChange(id);
        }
        setProcessing(false);
        setNewObjectMode(false);
        setNewObjectStr("");
      }, async (error) => {
        await api.addErrorLog({ file: "SelectAddableObjectBox.tsx", method: "addNewObject", obj: error });
      });
    }
  }

  if (!fetched || loading) {
    return (<LoadingBox />);
  } else if (newObjectMode) {
    return (
      <Grid container spacing={0} direction="row">
        <Grid
          size={{
            xs: 6
          }}>
          <StringBox
            name={`New ${type_name ? type_name : data_type}`}
            value={newObjectStr}
            disabled={processing || disabled}
            onBlur={setNewObjectStr}
          />
        </Grid>
        <Grid
          size={{
            xs: 6
          }}>
          <Button
            variant="contained"
            color="primary"
            disabled={processing || disabled}
            onClick={addNewObject}>
            Add
          </Button>
          <Button
            variant="contained"
            style={{ marginLeft: "4px" }}
            disabled={processing || disabled}
            onClick={ () => { 
              setNewObjectMode(false);
            }}>
            Cancel
          </Button>
        </Grid>
      </Grid>
    );
  } else {
    if (multiple) {
      return (
        <SelectObjectBox
          name={name}
          data_type={data_type}
          extra_options={[`New ${type_name ? type_name : data_type}`]}
          values={my_values}
          color={color}
          disabled={disabled}
          multiple
          auto_sort
          close_on_extra_clicked
          filter={filter}
          display_format={display_format}
          display_format_backup={display_format_backup}
          ignore_missing
          onChange={(changed: string[]) => {
            if (changed.includes(`New ${type_name ? type_name : data_type}`)) {
              setValues(changed.filter(o => o !== `New ${type_name ? type_name : data_type}`));
              setNewObjectMode(true);
            } else {
              setValues(changed);
              onChange(changed);
            }
          }}
        />
      );
    } else {
      return (
        <SelectObjectBox
          name={name}
          data_type={data_type}
          extra_options={[`New ${type_name ? type_name : data_type}`]}
          value={my_value}
          color={color}
          disabled={disabled}
          auto_sort
          filter={filter}
          display_format={display_format}
          display_format_backup={display_format_backup}
          onChange={(changed: string) => {
            if (changed === `New ${type_name ? type_name : data_type}`) {
              setNewObjectMode(true);
            } else {
              setValue(changed);
              onChange(changed);
            }
          }}
        />
      );
    }
  }
}
